import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=287d7206&scoped=true"
import script from "./additional.vue?vue&type=script&lang=js"
export * from "./additional.vue?vue&type=script&lang=js"
import style0 from "./additional.vue?vue&type=style&index=0&id=287d7206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d7206",
  null
  
)

export default component.exports